import "./App.css";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SupportBot from "./components/SupportBot";
import Home from "./pages/Home";
import Category from "./pages/Category";
import Marketplace from "./pages/Marketplace";
import Wallet from "./pages/Wallet";
import Services from "./pages/Services";
import Admin from "./pages/Admin";
import Build from "./pages/Build";
import Notebook from "./pages/Notebook";
import Deal from "./pages/Deal";
import CustomPage from "./pages/CustomPage";
import SitePage from "./pages/SitePage";
import AgentPage from "./pages/AgentPage";
import AdLanding from "./pages/AdLanding";
import { LegalPage, ToolsPage } from "./pages/LegalPages";
import { api } from "./lib/api";

function DomainEntry() {
  const [target, setTarget] = useState(null);
  useEffect(() => {
    let active = true;
    api.resolveDomain(window.location.hostname)
      .then((result) => { if (active) setTarget(result.mapped ? result.target : "/"); })
      .catch(() => { if (active) setTarget("/"); });
    return () => { active = false; };
  }, []);
  if (target === null || target === "/") return <Home />;
  return <Navigate to={target} replace />;
}

function App() {
  return (
    <div className="App min-h-screen bg-background" dir="rtl" lang="ar">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<DomainEntry />} />
          <Route path="/category/:id" element={<Category />} />
          <Route path="/ad/:id" element={<AdLanding />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service/:id" element={<Services />} />
          <Route path="/build" element={<Build />} />
          <Route path="/notebook" element={<Notebook />} />
          <Route path="/deal" element={<Deal />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/p/:slug" element={<CustomPage />} />
          <Route path="/site/:id" element={<SitePage />} />
          <Route path="/agent/:id" element={<AgentPage />} />
          <Route path="/legal/:page" element={<LegalPageRoute />} />
          <Route path="/tools" element={<ToolsPage />} />
        </Routes>
        <Footer />
        <SupportBot />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

function LegalPageRoute() {
  const { page } = useParams();
  return <LegalPage page={page} />;
}

export default App;
